import { Component, Input, OnInit } from '@angular/core';
import { ProjectItem, OutlineItem } from 'src/app/shared/models/base.models';

@Component({
  selector: 'app-wallet-item-popover',
  templateUrl: './wallet-item-popover.component.html',
  styleUrls: ['./wallet-item-popover.component.css']
})
export class WalletItemPopoverComponent implements OnInit {
  @Input() walletItem: OutlineItem;

  constructor() { }

  ngOnInit() {
  }

}
